import { NOT_AVAILABLE } from './template.constant';
import { MeasurementUnitCodesEnum } from '../models';

export enum UnitSystem {
  Metric = 'METRIC',
  Imperial = 'IMPERIAL',
}

export const MeasurementUnitCodesMap: Record<MeasurementUnitCodesEnum, string> = {
  [MeasurementUnitCodesEnum.Millimeters]: 'mm',
  [MeasurementUnitCodesEnum.Centimeters]: 'cm',
  [MeasurementUnitCodesEnum.Inches]: 'in',
  [MeasurementUnitCodesEnum.Feet]: 'ft',
  [MeasurementUnitCodesEnum.Meters]: 'm',
  [MeasurementUnitCodesEnum.Yard]: 'yd',
  [MeasurementUnitCodesEnum.Kilometers]: 'km',
  [MeasurementUnitCodesEnum.Miles]: 'mi',
  [MeasurementUnitCodesEnum.Milligrams]: 'mg',
  [MeasurementUnitCodesEnum.Grams]: 'g',
  [MeasurementUnitCodesEnum.Kilograms]: 'kg',
  [MeasurementUnitCodesEnum.Tonne]: 't',
  [MeasurementUnitCodesEnum.KiloTonne]: 'kt',
  [MeasurementUnitCodesEnum.Pound]: 'lb',
  [MeasurementUnitCodesEnum.CubicMeters]: 'm³',
  [MeasurementUnitCodesEnum.CubicCentimeters]: 'cm³',
  [MeasurementUnitCodesEnum.CubicInches]: 'in³',
  [MeasurementUnitCodesEnum.Liters]: 'l',
  [MeasurementUnitCodesEnum.CubicFeet]: 'ft³',
  [MeasurementUnitCodesEnum.CubicYard]: 'yd³',
  [MeasurementUnitCodesEnum.Unknown]: NOT_AVAILABLE,
};
